import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Col, Form, Card, Spinner, Button } from 'react-bootstrap';
import { AuthContext } from '../../../auth/AuthContext';
import { useContextInfo } from '../../../context/ContextInfo';
import { useGetDta } from '../../../hooks/useGetDta';
import LoadinSpin from '../../ui/LoadinSpin';
import { useForm } from '../../../hooks/useForm';
import { fetchConToken } from '../../../api/fetch';
import { smsN } from '../../../data/userSet';
import { daysBA } from '../../../data/loopMap';
import { checkAccess } from '../../../helpers/details';
const CardNotify = ({ activeTab, activo }) => {
    const { id } = useParams();
    let idR = atob(id);
    const { auth } = useContext(AuthContext);
    const permisos = checkAccess('Usuarios', auth.accesos);
    const { usr_editar } = permisos.functions;

    const [load, setLoad] = useState(false);
    const [validated, setValidated] = useState(false);
    const { setResp } = useContextInfo();
    const { loading, data, getInfo } = useGetDta(`user/datafac/${idR}`);
    const { aviso } = data;

    const [values, handleInputChange, setFormValue] = useForm({
        id: '',
        avisopantalla: 'Desactivado',
        recordatorio: 'Desactivado',
        sms: 'Desactivado',
    });
    useEffect(() => {
        setFormValue({ ...values, ...aviso });
    }, [data]);

    useEffect(() => {
        getInfo(`user/datafac/${idR}`);
    }, [idR, activeTab, activo]);
    const onSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        setLoad(true);
        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            let res = await fetchConToken('user/avisos', { ...values, id_user: idR }, 'PUT');
            if (res.ok) setFormValue({ ...res.data });
            setResp(res);
        }
        setLoad(false);
    };
    if (loading) return <LoadinSpin />;
    return (
        <Card>
            <Card.Header>
                {' '}
                <i className="mdi mdi-data-matrix" /> Notificaciones
            </Card.Header>{' '}
            <Card.Body>
                <Form noValidate validated={validated} onSubmit={onSubmit}>
                    <Col>
                        {' '}
                        <Form.Group className="mb-3" controlId="validationCustom0">
                            <Form.Label>Aviso en pantalla</Form.Label>
                            <Form.Select
                                value={values.avisopantalla}
                                name="avisopantalla"
                                required
                                onChange={handleInputChange}>
                                {smsN.map((d) => (
                                    <option value={d} key={d}>
                                        {d}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>{' '}
                    <Col>
                        {' '}
                        <Form.Group className="mb-3" controlId="validationCustom0">
                            <Form.Label> Recordatorio pago</Form.Label>
                            <Form.Select
                                value={values.recordatorio}
                                name="recordatorio"
                                required
                                onChange={handleInputChange}>
                                <option value={0}>Desactivado</option>
                                {daysBA()}
                            </Form.Select>
                        </Form.Group>
                    </Col>{' '}
                    <Col>
                        {' '}
                        <Form.Group className="mb-3" controlId="validationCustom0">
                            <Form.Label> Recordatorio #1</Form.Label>
                            <Form.Select value={values.sms} name="sms" required onChange={handleInputChange}>
                                {smsN.map((d) => (
                                    <option value={d + `re1`} key={d}>
                                        {d}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>{' '}
                    {load ? (
                        <Button color="primary" disabled>
                            <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                            Guardando...
                        </Button>
                    ) : (
                        <>{usr_editar && <Button type="submit">Guardar</Button>}</>
                    )}
                </Form>
            </Card.Body>
        </Card>
    );
};

export default CardNotify;
